import Title from '@/components/Title/index.vue';
import BrokerCard from '@/components/BrokerCard/index.vue';
export default {
  name: 'news-part',
  components: {
    Title,
    BrokerCard
  },
  data() {
    return {
      cardList: [{
        url: require('@/assets/images/service/information/news-card-pa.png'),
        text: '平安证券：同花顺资讯转发服务为平安证券提供了不同源资讯数据的统一采集，并提供专业的资讯处理能力接口，帮助平安证券快速提升资讯质量、扩展内容源。'
      }, {
        url: require('@/assets/images/service/information/news-card-ht.png'),
        text: '恒泰证券：同花顺为恒泰金玉管家APP建设一整套的资讯内容服务，为APP用户提供财经要闻、市场快讯、投资必读等十多个特色资讯模块，帮助投资者更有效的提升信息情报获取能力，帮忙平台更好的吸引用户留存。'
      }]
    };
  }
};